import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const CastingApplicantsChart = ({
  dashboardData,
  pieChartData,
  totalApplicantsCount,
  COLOR_MAP
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="cdd-card cdd-chart-card">
      <div className="cdd-card-header">
        <h2>Applicants Overview</h2>
        <select className="cdd-select">
          <option>Last 7 Days</option>
          <option>This Month</option>
        </select>
      </div>
      
      <div className="cdd-chart-wrapper">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  const data = payload[0];
                  const fillColor = COLOR_MAP[data.name] || "#3b82f6";
                  return (
                    <div className="cdd-tooltip-box">
                      <div className="cdd-tooltip-header">
                        <span className="cdd-tooltip-dot" style={{ backgroundColor: fillColor }}></span>
                        <p className="cdd-tooltip-title">{data.name}</p>
                      </div>
                      <p className="cdd-tooltip-val">
                        Count: <span>{data.value}</span>
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />

            <Pie
              data={pieChartData.length > 0 ? pieChartData : [{ name: "No Data", value: 1 }]}
              cx="50%"
              cy="50%"
              innerRadius={isMobile ? 54 : 62}
              outerRadius={isMobile ? 76 : 85}
              paddingAngle={4}
              dataKey="value"
              nameKey="name"
              cornerRadius={5}
              stroke="none"
            >
              {pieChartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLOR_MAP[entry.name] || "#3B82F6"}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div className="cdd-pie-center-overlay">
          <span className="cdd-pie-center-value">{totalApplicantsCount}</span>
          <span className="cdd-pie-center-label">Total</span>
        </div>
      </div>

      <div className="cdd-legend-container">
        <div className="cdd-legend-item">
          <span className="cdd-legend-dot dot-yellow"></span>
          <span className="cdd-legend-text">Pending</span>
        </div>
        <div className="cdd-legend-item">
          <span className="cdd-legend-dot dot-purple"></span>
          <span className="cdd-legend-text">Resubmit</span>
        </div>
        <div className="cdd-legend-item">
          <span className="cdd-legend-dot dot-green"></span>
          <span className="cdd-legend-text">Shortlisted</span>
        </div>
        <div className="cdd-legend-item">
          <span className="cdd-legend-dot dot-red"></span>
          <span className="cdd-legend-text">Rejected</span>
        </div>
      </div>
    </div>
  );
};

export default CastingApplicantsChart;
